<h3 class="mb-4 text-2xl">Banery marki</h3>

<app-admin-brand-banner-list
  [brandId]="brandId()"
  [reloadVersion]="reloadVersion()"
  (changedEvent)="handleChangedEvent()"
  (createClickEvent)="handleCreateClickEvent()"
  (editClickEvent)="handleEditClickEvent($event)"
  (previewClickEvent)="handlePreviewClickEvent($event)" />

@if (isDrawerVisible) {
  <p-drawer
    [customCloseEvent]="customCloseEvent"
    [visible]="true"
    appDrawerSidebar
    size="xl"
    position="right">
    <ng-template #header>
      <app-drawer-title>
        @switch (drawerMode()) {
          @case ('create') {
            Dodawanie baneru marki
          }
          @case ('edit') {
            Edycja baneru marki
          }
          @case ('details') {
            Szczegóły baneru marki
          }
        }
      </app-drawer-title>
    </ng-template>

    <ng-template #content>
      @switch (drawerMode()) {
        @case ('create') {
          <app-admin-brand-banner-create
            [brandId]="brandId()"
            (submitSuccessEvent)="handleSubmitSuccessEvent()" />
        }

        @case ('edit') {
          @if (activeBannerId(); as bannerId) {
            <app-admin-brand-banner-edit
              [bannerId]="bannerId"
              [brandId]="brandId()"
              (submitSuccessEvent)="handleSubmitSuccessEvent()" />
          }
        }

        @case ('details') {
          @if (activeBannerId(); as bannerId) {
            <app-admin-brand-banner-details
              [bannerId]="bannerId"
              [brandId]="brandId()" />
          }
        }
      }
    </ng-template>
  </p-drawer>
}
